import { FormikErrors } from "formik"
import { z } from "zod"

export const createFormikValidate = <T extends Record<string, unknown>>(schema: z.ZodType<any, any>) => {
  return (values: T): FormikErrors<T> => {
    try {
      schema.parse(values)
      return {}
    } catch (error) {
      if (error instanceof z.ZodError) {
        return error.flatten().fieldErrors as FormikErrors<T>
      } else {
        throw error
      }
    }
  }
}
